/** Presentation routes only; this registry never authorizes a workspace session. */
const WORKSPACE_ROOTS = ["/admin", "/client", "/analyst", "/senior", "/organization"] as const;
export function workspaceProfilePaths(path: string) {
  const root = WORKSPACE_ROOTS.find(value => path === value || path.startsWith(`${value}/`));
  if (!root) return null;
  const profile = `${root}/profile`;
  return { profile, languageRegion: `${profile}/language-region`, isProfile: path === profile || path.startsWith(`${profile}/`) };
}
